export default "__VITE_ASSET__CcgiLlY$__"